  <p class="title">
    Disbursement

    <mat-icon class="titleIcon">chevron_right</mat-icon> Proforma DA
  </p>
<div class="port-agent-form-container " [ngClass]="{ 'theme-dark': isDarkMode() }">
    <form [formGroup]="pdaCreateForm">
        <div class="field-section">
            <div style="margin-bottom: 1px; font-weight: 500;" class="label"> Port Disbursement Accounts</div>
            <div style="margin-bottom: 35px; font-size: 15px; color: #656565;"> Fill all required fields to accurately
                capture vessel
                information, port details, voyage data and financial inputs for the PDA.</div>
            <div class="field-grid">
                <div *ngFor="let field of fields; let i = index">
                    <!-- Select field -->
                    <mat-form-field *ngIf="field.type === 'select'" appearance="outline" class="mat-field-small">
                        <mat-label>{{ field.name }}</mat-label>
                        <input matInput [formControlName]="field.value" placeholder="Please select" placeholder="Enter {{ field.name }}"
                            [matAutocomplete]="auto" (click)="trigger.openPanel()" #trigger="matAutocompleteTrigger"
                            (blur)="onRemove(field)" />

                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelect(field.name, $event.option)"
                            [displayWith]="displayFn.bind(this, field)">
                            <mat-option *ngFor="let opt of getFilteredOptions(field)"
                                [value]="getOptionValue(field, opt, addedFields)">
                                {{ field.name === 'Cargo' ? opt?.type : (field.name === 'ToCurrency' || field.name ===
                                'FromCurrency') ? opt : opt?.name }}
                            </mat-option>
                        </mat-autocomplete>

                        <!-- Error handling -->
                        <mat-error *ngIf="pdaCreateForm.get(field.value)?.hasError('required')">
                            Please select the {{ field.name }}.
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="field.type === 'date'">
                        <mat-label>{{ field.name }}</mat-label>
                        <input matInput [matDatepicker]="picker" [formControlName]="field.value" placeholder="Enter {{ field.name }}"
                            (dateChange)="onDateChange()" />
                        <mat-datepicker-toggle matIconSuffix [for]="picker">
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <mat-error *ngIf="pdaCreateForm.get(field.value)?.hasError('required')">
                            please select the {{ field.name }}
                        </mat-error>
                    </mat-form-field>


                    <!-- Default input field -->
                    <mat-form-field *ngIf="field.type !== 'date' && field.type !== 'select'" appearance="outline"
                        class="mat-field-small">
                        <mat-label>{{ field.name }}</mat-label>
                        <input matInput [type]="field.data_type || 'text'" [formControlName]="field.value" placeholder="Enter {{ field.name }}"
                            (blur)=" field.name === 'Vessel Stay'? validateVesselStay(field , pdaCreateForm) :null  "
                            [readonly]="field.pdaReadOnly" />

                        <!-- Error message for required field -->
                        <mat-error *ngIf="pdaCreateForm.get(field.value)?.hasError('required')">
                            {{ field.name }} is required
                        </mat-error>
                        <!-- Custom error for invalid number -->
                        <mat-error
                            *ngIf=" field.name === 'Vessel Stay'&& pdaCreateForm.get(field.value)?.hasError('invalidFormat')">
                            valid format (e.g., 1D, 1H, 1D 1H,). </mat-error>
                        <mat-error
                            *ngIf="field.name === 'Invoice Ref No' && pdaCreateForm.get(field.value)?.hasError('invalidData')">
                            Enter Valid Format
                        </mat-error>

                    </mat-form-field>

                </div>
            </div>
        </div>
        <div class="clear-submit-btn">
            <button class="clear-btn" (click)="clearData()">Clear All</button>
            <button class="proceed-pda-btn" type="button" (click)="proceedToPda()"
                [disabled]="disableProceedToPdabutton" [class.btn-disabled]="disableProceedToPdabutton" *ngIf="username === 'Meraki - Operations'">Proceed to
                PDA</button>
            <button class="submit-button" type="button" (click)="openEmailDialog()"
                [disabled]="disablesendRequestButton" [class.btn-disabled]="disablesendRequestButton">Send Request
            </button>
        </div>

    </form>
</div>